import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

import { BootstrapSandboxService } from '@bootstrap/sandbox/bootstrap.sandbox.service';

import { Toast } from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'ser-root',
    templateUrl: './root-container.component.html'
})
export class RootContainerComponent implements OnInit {
    toasts$!: Observable<Toast[]>;
    isTokenValid$!: Observable<boolean | undefined>;

    constructor(private readonly sandbox: BootstrapSandboxService) {}

    ngOnInit(): void {
        this.setupLoadingStream();
        this.setupToastsStream();
    }

    deleteToastById(toastId: number): void {
        this.sandbox.deleteToast(toastId);
    }

    private setupLoadingStream(): void {
        this.isTokenValid$ = this.sandbox.isTokenValid$.pipe(startWith(undefined));
    }

    private setupToastsStream(): void {
        this.toasts$ = this.sandbox.toasts$;
    }
}
